<template>
  <ODialog ref="dialog" :maxWidth="400">
    <v-card>
      <ODialogBar title="Exportar ScreenSets" @close="dismiss" />

      <v-card-text class="pa-6">
        <p>
          Esta funcionalidade permite exportar os objetos selecionados para um
          arquivo no seu computador.
        </p>
        <v-text-field v-model="fname" hide-details label="Nome do arquivo" />
      </v-card-text>

      <ODialogButtons
        class="pa-6"
        @cancel="dismiss"
        @apply="exportJson"
        :txtApply="`Exportar ${rows.length} objetos`"
      />
    </v-card>
  </ODialog>
</template>

<script>
import moment from 'moment'
import { saveAs } from 'oderon-vue/utils'

export default {
  data() {
    return { fname: null, rows: [] }
  },
  methods: {
    open(rows) {
      let strDate = moment().format('YYYYMMDD')
      this.fname = `${strDate}-screensets.json`
      this.rows = rows || []

      return this.$refs.dialog.$open()
    },

    dismiss() {
      this.$refs.dialog.$dismiss()
    },

    exportJson() {
      let str = JSON.stringify(this.rows, null, ' ')
      saveAs(str, this.fname)
      this.dismiss()
    }
  }
}
</script>

<style></style>
